module.exports = __webpack_public_path__ + "static/media/main1_en.ba740d61.png";